module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert.component.scss
// module id = ./src/app/features/message-alert/message-alert.component.scss
// module chunks = main